<div [ngClass]="{blog: isBlog}">
  <h1 *ngIf="title">
    {{ title }}
  </h1>

  <mbnm-navigation-tiles [tileCollection]="cmsData" [enableHero]="true">

  </mbnm-navigation-tiles>

  <mat-spinner color="secondary" *ngIf="!cmsData"></mat-spinner>
</div>
